export const GET_CATEGORIES = "get_categories";
export const EDIT_CATEGORIES = "edit_categories";
export const NEW_CATEGORY = "new_category";
export const GET_ACCESS_RIGHTS = "get_access_right";
export const DELETE_CATEGORY = "delete_category";
export const START_LOADING = "start_loading";
export const STOP_LOADING = "stop_loading";
export const ERROR = "error";
export const ACCESS_RIGHT_ERROR = "access_error";
